export default [
  "date",
  "time",
  "position_number",
  "household_count",
  "household_member_0_first_name",
  "household_member_0_middle_name",
  "household_member_0_last_name",
  "household_member_0_email",
  "household_member_0_primary_phone",
  "household_member_0_primary_phone_type",
  "household_member_0_secondary_phone",
  "household_member_0_secondary_phone_ext",
  "household_member_0_secondary_phone_type",
  "household_member_0_dob",
  "applicant_homeless_or_no_residence",
  "residence_address1",
  "residence_ste_number",
  "residence_city",
  "residence_state",
  "residence_zip",
  "mailing_address1",
  "mailing_ste_number",
  "mailing_city",
  "mailing_state",
  "mailing_zip",
  "mailing_address_type",
  "total_income",
  "unit_size",
  "unit_size_studio",
  "unit_size_1br",
  "unit_size_1br_den",
  "unit_size_2br",
  "unit_size_3br",
  "unit_size_4br",
  "unit_size_5br",
  "unit_size_sro",
  "household_has_housing_authority_voucher",
  "household_receives_other_housing_assistance",
  "household_receives_other_housing_assistance_subsidy_type",
  "household_requires_impairment_mobility",
  "household_requires_impairment_visual",
  "household_requires_impairment_hearing",
  "household_served_in_armed_forces",
  "household_member_1_first_name",
  "household_member_1_last_name",
  "current_resident",
  "denied",
  "denial_reason",
  "moved_in",
  "movein_unit_no",
  "custom_pref_1",
  "custom_pref_2",
  "custom_pref_3",
  "custom_pref_4",
  "custom_pref_5",
  "custom_pref_6",
  "custom_pref_7",
  "custom_pref_8",
  "custom_pref_9",
  "custom_pref_10",
  "custom_pref_11",
  "custom_pref_12",
  "custom_pref_13",
  "custom_pref_14",
  "custom_pref_1_answer",
  "custom_pref_2_answer",
  "custom_pref_3_answer",
  "custom_pref_4_answer",
  "custom_pref_5_answer",
  "custom_pref_6_answer",
  "custom_pref_7_answer",
  "custom_pref_8_answer",
  "custom_pref_9_answer",
  "custom_pref_10_answer",
  "custom_pref_11_answer",
  "custom_pref_12_answer",
  "custom_pref_13_answer",
  "custom_pref_14_answer",
  "contact_name",
  "contact_relation",
  "contact_primary_phone",
  "contact_primary_phone_ext",
  "contact_email",
  "applicant_prefered_contact_type",
  "household_has_pets",
  "how_did_applicant_hear_about_property",
  "household_ami",
  "ami_0br_40",
  "ami_0br_50",
  "ami_0br_80",
  "ami_1br_40",
  "ami_1br_50",
  "ami_1br_80",
  "ami_2br_40",
  "ami_2br_50",
  "ami_2br_80",
  "ami_3br_40",
  "ami_3br_50",
  "ami_3br_80",
  "household_member_0_ethnic_category",
  "household_member_0_race_amer_indian_alaskan_native",
  "household_member_0_race_asian",
  "household_member_0_race_african_american",
  "household_member_0_race_native_hawaiian_or_other_pac_islander",
  "household_member_0_race_white",
  "household_member_0_race_other",
  "notes",
  "skips",
  "household_member_0_middle_name",
  "household_member_0_social",
  "unit_size_5br",
  "contact_reason_emergency",
  "contact_reason_unable_to_contact",
  "contact_reason_termination_of_rental_assist",
  "contact_reason_eviction_from_unit",
  "contact_reason_late_payment_of_rent",
  "household_all_full_time_students",
  "household_has_special_accommodations",
  "unit_size_shared",
  "household_member_0_gender",
];
